import { useMemo } from "react";
import RemesaGroupsContainer from "./RemesaGroupsContainer";
import { StateManager } from "../service/StateManager";
import "../../../css/OnRoad.css";

export default function RemesaDetails({ operacionData, informacionEstado }) {
    // Agrupar remesas usando el método de StateManager (ya ordenado)
    const gruposRuta = useMemo(() => {
        if (!operacionData?.remesas) {
            return [];
        }
        // Usar método centralizado que ya ordena alfabéticamente
        return StateManager.agruparRemesasPorRuta(operacionData.remesas);
    }, [operacionData?.remesas]);

    // Si no hay remesas, no renderizar nada
    if (gruposRuta.length === 0) {
        return null;
    }

    return (
        <div className="remesa-details-container">
            {/* Usar el nuevo componente contenedor en lugar de renderizar directamente */}
            <RemesaGroupsContainer 
                gruposRuta={gruposRuta}
            />
        </div>
    );
}